import CONTRACT_INGESTION_API_URLS from './api_urls/ContractIngestionApiUrls'
import NEXUS_API_URLS from './api_urls/NexusApiUrls'
import OS_API_URLS from './api_urls/OsApiUrls'
import SETTLEMENT_API_URLS from './api_urls/SettlementApiUrls'

const API_URLS = {
    settlement: SETTLEMENT_API_URLS,
    os: OS_API_URLS,
    nexus: NEXUS_API_URLS,
    contractIngestion: CONTRACT_INGESTION_API_URLS
}

export default API_URLS
